import CallEvent from '../builders/callEvent'

const publishEvent = (eventName, payload = {}) => {
  new CallEvent().withPayload(payload).buildEvent(eventName).publishEvent()
}

export { publishEvent }
